import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { TrashButton } from '@checkmarx/cx-ui';
import ToastrLevelsEnum from '../../../../services/enums/toastrLevelsEnum';
import ToastrService from '../../../../services/ui/toastrService';
import DeleteDialog from '../../../portal/dialogs/deleteDialog';
import ErrorDialog from '../../../portal/dialogs/errorDialog';

@inject('translationsStore', 'ldapTeamMappingStore', 
    'teamMembersStore', 'teamsStore', 'groupMapping') @observer
export default class RemoveGroupMapping extends Component {

    state = {
        openDeleteDialog: false,
        openErrorDialog: false
    };

    openDeleteDialog = () => {

        this.setState({ 
            openDeleteDialog: true
        }); 
    }

    closeDeleteDialog = () => {

        this.setState({ 
            openDeleteDialog: false
        }); 
    }

    openErrorDialog = () => {

        this.setState({ 
            openErrorDialog: true
        }); 
    }

    closeErrorDialog = () => {

        this.setState({ 
            openErrorDialog: false
        }); 
    }

    handleDeleteDialogConfirm = () => {

        this.deleteGroupMapping();
    }

    deleteGroupMapping = () => {

        this.props.ldapTeamMappingStore.delete(this.props.id)
            .then(() => {

                this.props.ldapTeamMappingStore.getByTeamId(this.props.teamsStore.selectedTeamId);
                this.props.groupMapping.removeEntryId(this.props.ldapGroupDn);
                var level = ToastrLevelsEnum.SUCCESS;
                var message = this.props.translationsStore.translate('GROUP_MAPPING_REMOVED_SUCCESSFULLY');
                ToastrService.triggerToastr({level, message});
            })
            .catch(() => {
                
                this.openErrorDialog();
            })
            .finally(() => {

                this.closeDeleteDialog();
            });
    }

    getTeamName() {

        let teamName = this.props.teamsStore.teams.filter((t) => t.id == this.props.teamsStore.selectedTeamId);

        if(teamName && teamName.length > 0) {

            return teamName[0].name;
        }
    }

    render() {

        const teamName = this.getTeamName();
        const message = this.props.translationsStore.translate('UNMAP_LDAP_GROUP_MESSAGE')
                            .replace('{groupname}', this.props.groupName)
                            .replace('{teamname}', teamName);

        return(
            <div className='remove-user-column'>
                <TrashButton onClick={this.openDeleteDialog} />
                <DeleteDialog 
                    show={this.state.openDeleteDialog}
                    onConfirm={this.deleteGroupMapping}
                    deleteButtonText={this.props.translationsStore.translate('UNMAP')}
                    cancelText={this.props.translationsStore.translate('CANCEL')}                                
                    closeDeleteDialog={this.closeDeleteDialog}
                    titleText={this.props.translationsStore.translate('UNMAP_LDAP_GROUP')}
                    contentText={message}
                    inProgress={this.props.ldapTeamMappingStore.deleteLdapTeamMappingsProgress}
                />
                <ErrorDialog 
                    show={this.state.openErrorDialog}
                    onConfirm={this.closeErrorDialog}
                    deleteButtonText={this.props.translationsStore.translate('CLOSE')}
                    closeDeleteDialog={this.closeErrorDialog}
                    titleText={this.props.translationsStore.translate('ERROR')}
                    contentText={this.props.ldapTeamMappingStore.deleteLdapTeamMappingsErrorMessage}
                />
            </div>
        );
    }
}